<div class="mobile-header">
  <a class="back-btn text-white" [routerLink]="['/games']">
    <i class="material-icons">arrow_back_ios</i>
  </a>
  <h5 class="title">{{ 'quiz.page.title' | translate }}</h5>
</div>
<fgb-mobile-banner></fgb-mobile-banner>
<div class="nav-container">
  <div class="container">
    <div class="tab-container">
      <fgb-route-nav>
        <a
          class="nav-item"
          [routerLink]="['/games/trivia']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <label>{{ 'games.nav.play' | translate }}</label>
          <div class="nav-item-bg"></div>
        </a>
        <a
          class="nav-item"
          [routerLink]="['/games/trivia/leaderboard']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <label>{{ 'games.nav.leaderboard' | translate }}</label>
          <div class="nav-item-bg"></div>
        </a>
      </fgb-route-nav>
    </div>
  </div>
</div>

<router-outlet></router-outlet>
